import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onBeforeMount} from 'vue';
import Config from "../service/Config";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainFooterComponent',
  setup(__props) {

const version = ref('0.0.0');
const versionChars = ref([]);
onBeforeMount(() => {
  load();
})

function load() {
    if (Config.version < 100) {
        versionChars.value.push(0);
    }
    for (let configV of Config.version) {
        versionChars.value.push(configV);
    }
    version.value = versionChars.value.join('.');
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, {
    class: "py-3 small-footer",
    width: "50"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "mx-2 d-flex flex-wrap flex-direction-column"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "9"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "© 2009 – " + _toDisplayString(new Date().getFullYear()) + " CodeREADr Inc. All Rights Reserved.", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_spacer, { class: "d-none d-sm-flex" }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "auto",
            class: "text-left text-sm-right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, "version " + _toDisplayString(version.value), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})